module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sandra Rodriguez Barron\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Sandra Rodriguez Barron is the author of "), _c('I', [_vm._v("The Heiress of Water")]), _vm._v(", winner of the International Latino Book Award for debut fiction. The recipient of a Bread Loaf Fellowship and a National Association of Latino Arts and Culture Grant, she was born in Puerto Rico, lived in the Dominican Republic and El Salvador, and now lives with her family in Connecticut.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/FZNJxc/tc-custom/9780062030580.jpg?1732134083568",
      "alt": "This image is the cover for the book Stay with Me"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Stay with Me\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("“"), _c('i', [_vm._v("Stay With Me")]), _vm._v(" accomplishes all we might ask of a novel….It reminds readers what great pleasures and surprises are to be found inside such rare, fine, and atmospheric novels when we’re lucky enough to find them.”"), _c('br'), _vm._v("—Laura Kasischke, author of "), _c('i', [_vm._v("In a Perfect World")])]), _c('p'), _c('p'), _c('i', [_vm._v("Stay With Me ")]), _vm._v("by Sandra Rodriguez Barron is a gripping and deftly written novel about the meaning of family and the bonds that create one’s history. Provocative and character-rich, "), _c('i', [_vm._v("Stay With Me ")]), _vm._v("grippingly explores the mystery behind the pasts of five toddlers who were stranded on a boat and left drifting in the ocean, and the aftermath, many years later. Literary giant Isabel Allende has raved about this author’s work, saying, “Rodriguez Barron’s exuberant prose yields an immensely entertaining reading experience.”\n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0